module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav-main",
    class: {
      owner: _vm.$onduro.hasRole('owner')
    }
  }, [_c('a', {
    staticClass: "toggle-menu",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleNavigation()
      },
      "touchstart": function($event) {
        _vm.touching = true
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "menu",
      "viewBox": "0 0 24 24"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    staticClass: "link-home",
    attrs: {
      "to": _vm.$onduro.route('overview')
    }
  }, [_c('icon', {
    attrs: {
      "name": "logo",
      "viewBox": "0 0 842 170"
    }
  })], 1), _vm._v(" "), (_vm.appReady) ? _c('ul', [_c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('overview')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.overview.name')),
      expression: "showTooltip('route.overview.name')"
    }],
    attrs: {
      "name": "inbox"
    }
  }), _vm._v(_vm._s(_vm.$t("route.overview.name")) + "\n            ")], 1)], 1), _vm._v(" "), _c('li', [(
    _vm.$onduro.hasModule('company') &&
    (_vm.$onduro.getConfig('company.visible') ||
      _vm.$onduro.hasRole('manager'))
  ) ? _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('company')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.company.name')),
      expression: "showTooltip('route.company.name')"
    }],
    attrs: {
      "name": "company"
    }
  }), _vm._v(_vm._s(_vm.$t("route.company.name")) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.$onduro.hasModule('checkins') &&
    _vm.$onduro.hasRole('supervisor')
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('checkins')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.checkins.name')),
      expression: "showTooltip('route.checkins.name')"
    }],
    attrs: {
      "name": "checkin"
    }
  }), _vm._v(_vm._s(_vm.$t("route.checkins.name"))), _c('i', {
    staticClass: "beta"
  }, [_vm._v("BETA")])], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.isReal() &&
    _vm.$onduro.hasModule('today') &&
    _vm.$onduro.hasRole(['planner', 'observer'])
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('today')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.today.name')),
      expression: "showTooltip('route.today.name')"
    }],
    attrs: {
      "name": "spot"
    }
  }), _vm._v(_vm._s(_vm.$t("route.today.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('li', [(
    _vm.$onduro.isReal() &&
    _vm.$onduro.hasModule('clients') &&
    _vm.$onduro.hasRole('planner', 'manager', 'owner')
  ) ? _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('clients')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.clients.name')),
      expression: "showTooltip('route.clients.name')"
    }],
    attrs: {
      "name": "apartment"
    }
  }), _vm._v(_vm._s(_vm.$t("route.clients.name")) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.$onduro.isReal() &&
    _vm.$onduro.hasModule('planning') &&
    _vm.$onduro.hasRole('planner', 'observer') &&
    _vm.$store.state.current.membership.locations.length
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('planning')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.planning.name')),
      expression: "showTooltip('route.planning.name')"
    }],
    attrs: {
      "name": _vm.$onduro.hasRole('planner') ? 'calendar' : 'eye'
    }
  }), _vm._v(_vm._s(_vm.$t("route.planning.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.isReal() &&
    _vm.$onduro.hasModule('planning') &&
    _vm.$store.state.current.membership.locations.length
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('roster')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.roster.name')),
      expression: "showTooltip('route.roster.name')"
    }],
    attrs: {
      "name": "assignment"
    }
  }), _vm._v(_vm._s(_vm.$t("route.roster.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('lists') && _vm.$onduro.hasRole('planner')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('lists')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.lists.name')),
      expression: "showTooltip('route.lists.name')"
    }],
    attrs: {
      "name": "list"
    }
  }), _vm._v(_vm._s(_vm.$t("route.lists.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.isReal() && _vm.showAvailability) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('availability')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.availability.name')),
      expression: "showTooltip('route.availability.name')"
    }],
    attrs: {
      "name": "checkmark"
    }
  }), _vm._v(_vm._s(_vm.$t("route.availability.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.isReal() &&
    _vm.$onduro.hasModule('contacts') &&
    (_vm.$onduro.hasRight('contacts.view') ||
      _vm.$onduro.getConfig('contacts.visibility'))
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('contacts')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.contacts.name')),
      expression: "showTooltip('route.contacts.name')"
    }],
    attrs: {
      "name": "phone"
    }
  }), _vm._v(_vm._s(_vm.$t("route.contacts.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('chats')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('chats')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.chats.name')),
      expression: "showTooltip('route.chats.name')"
    }],
    attrs: {
      "name": "chat"
    }
  }), _vm._v(_vm._s(_vm.$t("route.chats.name")) + "\n                "), _c('chat-bubble', {
    attrs: {
      "getter": "chat/countUnread",
      "limit": "99"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.isReal() &&
    _vm.$onduro.hasModule('hours') &&
    _vm.$onduro.hasRole('biller', 'supervisor')
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('hours')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.hours.name')),
      expression: "showTooltip('route.hours.name')"
    }],
    attrs: {
      "name": "clock"
    }
  }), _vm._v(_vm._s(_vm.$t("route.hours.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.hasModule('balances') &&
    (_vm.balance || _vm.$onduro.hasRight('balances.overview'))
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('balances')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.balances.name')),
      expression: "showTooltip('route.balances.name')"
    }],
    attrs: {
      "name": "balance"
    }
  }), _vm._v(_vm._s(_vm.$t("route.balances.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.hasModule('hours') && _vm.$onduro.hasRole('accountant')
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('reports')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.reports.name')),
      expression: "showTooltip('route.reports.name')"
    }],
    attrs: {
      "name": "calculator"
    }
  }), _vm._v(_vm._s(_vm.$t("route.reports.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.isReal() &&
    _vm.$onduro.hasModule('statistics') &&
    _vm.$onduro.hasRole(['accountant', 'owner'])
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('statistics')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.statistics.name')),
      expression: "showTooltip('route.statistics.name')"
    }],
    attrs: {
      "name": "stats"
    }
  }), _vm._v(_vm._s(_vm.$t("route.statistics.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.viewport !== 'd' ||
    !_vm.$onduro.hasRole(['owner', 'planner', 'manager'])
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('profile')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.profile.name')),
      expression: "showTooltip('route.profile.name')"
    }],
    attrs: {
      "name": "profile"
    }
  }), _vm._v(_vm._s(_vm.$t("route.profile.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('documents')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('documents')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.documents.name')),
      expression: "showTooltip('route.documents.name')"
    }],
    attrs: {
      "name": "insert-drive-file"
    }
  }), _vm._v(_vm._s(_vm.$t("route.documents.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasRight('user.edit')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('team')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.team.name')),
      expression: "showTooltip('route.team.name')"
    }],
    attrs: {
      "name": "team"
    }
  }), _vm._v(_vm._s(_vm.$t("route.team.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.hasModule('resources') &&
    (_vm.$onduro.hasRight('user.edit') ||
      _vm.$onduro.hasRole('planner'))
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('resources')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.resources.name')),
      expression: "showTooltip('route.resources.name')"
    }],
    attrs: {
      "name": "car"
    }
  }), _vm._v(_vm._s(_vm.$t("route.resources.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$current.account.sko && _vm.$onduro.hasRole('owner', 'manager')
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('log')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.log.name')),
      expression: "showTooltip('route.log.name')"
    }],
    attrs: {
      "name": "log"
    }
  }), _vm._v(_vm._s(_vm.$t("route.log.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.hasModule('absence') &&
    _vm.$onduro.hasRole(['owner', 'manager', 'planner'])
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('absences')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.absences.name')),
      expression: "showTooltip('route.absences.name')"
    }],
    attrs: {
      "name": "ambulance"
    }
  }), _vm._v(_vm._s(_vm.$t("route.absences.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.hasRole('owner', 'manager') &&
    !_vm.$current.membership.restrictions.manager.limited
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('settings')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.settings.name')),
      expression: "showTooltip('route.settings.name')"
    }],
    attrs: {
      "name": "cog"
    }
  }), _vm._v(_vm._s(_vm.$t("route.settings.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.$onduro.isReal() &&
    _vm.$onduro.hasRole('owner', 'manager') &&
    !_vm.$current.account.sko
  ) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('modules')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.modules.name')),
      expression: "showTooltip('route.modules.name')"
    }],
    attrs: {
      "name": "modules"
    }
  }), _vm._v(_vm._s(_vm.$t("route.modules.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.current.user.demo) ? _c('li', {
    staticClass: "help"
  }, [_c('a', {
    staticClass: "router-link box-intercom",
    attrs: {
      "href": "mailto:support@onduro.com"
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('text.help')),
      expression: "showTooltip('text.help')"
    }],
    attrs: {
      "name": "help"
    }
  }), _vm._v(_vm._s(_vm.$t("text.help")) + "\n            ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasRole('owner')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('subscription')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.subscription.name')),
      expression: "showTooltip('route.subscription.name')"
    }],
    attrs: {
      "name": "company"
    }
  }), _vm._v(_vm._s(_vm.$t("route.subscription.name")) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.current.user.super) ? _c('li', [_c('a', {
    staticClass: "router-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$widget.open('switcher')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "switch"
    }
  }), _vm._v("Switch\n            ")], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "languages"
  }, [_c('router-link', {
    class: _vm.$store.state.meta.lang == 'de' ? 'is-active' : '',
    attrs: {
      "to": _vm.$onduro.switchLanguage('de')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('de')
      }
    }
  }, [_vm._v("DE")]), _vm._v("\n            |\n            "), _c('router-link', {
    class: _vm.$store.state.meta.lang == 'nl' ? 'is-active' : '',
    attrs: {
      "to": _vm.$onduro.switchLanguage('nl')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('nl')
      }
    }
  }, [_vm._v("NL")]), _vm._v("\n            |\n            "), _c('router-link', {
    class: _vm.$store.state.meta.lang == 'en' ? 'is-active' : '',
    attrs: {
      "to": _vm.$onduro.switchLanguage('en')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('en')
      }
    }
  }, [_vm._v("EN")]), _vm._v(" "), (_vm.$current.profile == 'Pier14') ? [_vm._v("\n                |\n                "), _c('router-link', {
    class: _vm.$store.state.meta.lang == 'pl' ? 'is-active' : '',
    attrs: {
      "to": _vm.$onduro.switchLanguage('pl')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('pl')
      }
    }
  }, [_vm._v("PL")])] : _vm._e()], 2), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "version",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.refresh.apply(null, arguments)
      }
    }
  }, [_vm._v("V #" + _vm._s(_vm.version))])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91b7e68e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/modules/Navigation.vue
// module id = 484
// module chunks = 225